import {
	PersonStatusColorMap,
	getPersonStatusText,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	DocumentWorkflowInstanceSignatureStatus,
	InvestmentProgrammeDocumentRes,
} from '@dealstack/shared/lib/generated';
import { Text, Tooltip } from '@mantine/core';

interface Props {
	investor: InvestmentProgrammeDocumentRes['investor'][number];
}

export const InvestorName = ({ investor }: Props) => {
	const tMipManage = useTranslationMipManage();
	const isNoSignatureRequired = investor.status == null;
	const name = `${investor.firstName ?? ''} ${investor.lastName ?? ''}`.trim() || '-';
	const color = isNoSignatureRequired
		? PersonStatusColorMap.NO_SIGNATURE_REQUIRED
		: PersonStatusColorMap[investor.status ?? DocumentWorkflowInstanceSignatureStatus.CREATED];
	const text = (
		<Text c={color}>
			{investor.firstName} {investor.lastName}
		</Text>
	);
	if (isNoSignatureRequired) {
		return (
			<Tooltip label={`${name} • ${getPersonStatusText(null, tMipManage)}`} withArrow>
				<span>{text}</span>
			</Tooltip>
		);
	}
	return text;
};
